import React, { SFC } from 'react'
import { GameWithCpu } from './practice/GameWithCpu'
import { AppHeader } from '../components/AppHeader'

const style = {
  marginTop: '100px'
};

export const PracticePage: SFC = () => (
  <div className="container">
    <AppHeader />
    <div className="container" style={style}>
      <GameWithCpu />
    </div>
  </div>
)
